import { getCroppingCommands, getFieldCommands } from "../commands"
import { EditCroppingCmd } from "../editCroppingCmd"
import { components, FieldViewModel, isFieldViewModel, str } from "../omnia"
import { IFieldsModuleContext } from "../types"

import OmniaCommandGroup = components.OmniaCommandGroup

type IFieldYear = omnia.fields.timeline.IFieldYear

export function getContextMenuPosition(host: Element, clientX: number, clientY: number) {

    const leftOffset = -5
    const topOffset = -10
    const minRightMargin = 150
    const minRightMarginSubmenu = 400

    const rect = host.getBoundingClientRect()

    let x = (clientX - rect.left) + leftOffset

    const margin = rect.width - x

    if (margin < minRightMargin) {
        x = Math.max(0, x - minRightMargin)
    }

    const offsetLeft = (margin < minRightMarginSubmenu)

    const y = (clientY - rect.top) + topOffset

    return {
        x,
        y,
        offsetLeft
    }

}

export function getCommands(target: FieldViewModel | IFieldYear, context: IFieldsModuleContext) {

    const commands = isFieldViewModel(target)
        ? getFieldViewModelCommands(target, context)
        : getFieldYearCommands(target, context)

    return commands
        ? [commands]
        : []

}

function getFieldViewModelCommands(target: FieldViewModel, context: IFieldsModuleContext) {

    return target.isCropping()
        ? new OmniaCommandGroup(str.CroppingPlural, target, getCroppingCommands(context, true))
        : new OmniaCommandGroup(str.Field, target, getFieldCommands(context, true))

}

function getFieldYearCommands(target: IFieldYear, context: IFieldsModuleContext) {

    const { shell } = context

    return new OmniaCommandGroup(null, target, [
        new EditCroppingCmd(context, shell, target.field.fieldId, target.year)
    ]);

}
